import Push from 'push.js';

export default {
  data: () => ({
    pusherChannel: null
  }),

  created() {
    this.pusherChannel = this.$pusher;
    this.subscribeChannel();
  },

  methods: {
    subscribeChannel() {
      return this.pusherChannel.subscribe(this.$store.getters.getPusherChannel);
    },

    pusherWebNotifications(body, titulo = 'Hexa', icon = '/favicon.ico') {
      return Push.create(titulo, {
        body: body,
        icon: icon,
        timeout: 5000,
        onClick: function () {
          window.focus();
          this.close();
        }
      });
    },

    openPusherWebNotificChannel() {
      this.clearPusherChannels();

      const userIdHexa = this.$store.getters.getUserIdHexa;
      const existUserIdHexaInVuex = userIdHexa == undefined ? false : true;

      if (existUserIdHexaInVuex) {
        this.pusherChannel.bind(`webnotificacoes-${userIdHexa}`, (data) => {
          let msg = JSON.stringify(data.message);
          msg = msg.replace(/"/g, ''); /* retira aspas da string */
          this.pusherWebNotifications(msg);
        });
      }
    },

    /**
     * Remove todos os manipuladores de eventos do canal
     **/
    clearPusherChannels() {
      this.pusherChannel.unbind();
    }
  }
};
